module.exports = "<div class=\"btn-layout-middle show-waves\"><a target=\"_blank\" ng-href=\"{{$ctrl.selectedImage}}\" ng-show=\"$ctrl.isImage($ctrl.selectedFact)\"><img id=\"screenshot-image\" ng-src=\"{{$ctrl.selectedImage}}\" err-src=\"/static/img/default.png\"></a><div ng-if=\"!$ctrl.isImage($ctrl.selectedFact)\" class=\"btn-layout-middle-content\"><sc-fact-info filter=\"$ctrl.filter\" fact=\"$ctrl.selectedFact\"></sc-fact-info></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/facts/slider/facts-slider-view.component.html
// module id = 922
// module chunks = 0